import {
  AutoGraphOutlined,
  BlurOnOutlined,
  IntegrationInstructionsOutlined,
  ReceiptLongOutlined,
  SettingsSuggestOutlined,
  ThunderstormOutlined,
} from "@mui/icons-material";

export const projectCardsMock = [
  {
    title:
      "Enterprise integration of AI services for a global technology group",
    description:
      "We led the strategic implementation of LLMs into the client's Cloud environment (e.g. GPT-4 in Azure Cloud). This included migrating services, integrating with existing cognitive services, and developing processes to transform GPT knowledge into specialized embedding models.",
    icon: <ThunderstormOutlined color="primary" fontSize="large" />,
  },
  {
    title: "Secure End-to-End OCR-to-LLM Pipeline for User Data",
    description:
      "We built a complete, on-premise solution to capture, transform, and analyze sensitive patient notes via OCR, preparing the data for interaction with a specialized, securely hosted open-source LLM, fully respecting GDPR.",
    icon: <AutoGraphOutlined color="primary" fontSize="large" />,
  },
  {
    title: "LLM Agent System for Content Marketing",
    description:
      'We developed agentic pipelines where specialized AI agents work together. A "persona agent" defines the target group, while other agents design, generate and evaluate texts and images based on this.',
    icon: <BlurOnOutlined color="primary" fontSize="large" />,
  },
  {
    title: "Implementation of Company Knowledge  Chat Assistant Systems",
    description:
      " We led a strategic initiative for a company-wide chatbot with deep SharePoint integration, creating a secure and powerful knowledge portal for user and agent management.",
    icon: <ReceiptLongOutlined color="primary" fontSize="large" />,
  },
  {
    title:
      "Engineering a Journalistic Agent with Fact Check & Hallucination Detection",
    description:
      "We developed a specialized journalistic agent that could draft articles and—crucially—implemented a tailored metric system to detect and eliminate hallucinations, false information, ensuring factual accuracy.",
    icon: <SettingsSuggestOutlined color="primary" fontSize="large" />,
  },
  {
    title: "Agentic Invoice Automation",
    description:
      "An on-premise agentic system using a vision agent to automate complex invoicing. It intelligently interprets diverse formats, ensuring full data sovereignty and GDPR compliance by operating entirely within your infrastructure.",
    icon: <IntegrationInstructionsOutlined color="primary" fontSize="large" />,
  },
];
